import Work1 from "../../assets/Classified.png";
import Work2 from "../../assets/Warehouse.png";
import Work3 from "../../assets/Turf.png";
import Work4 from "../../assets/Guirdian.png";
import Work5 from "../../assets/Product.png";
import Work6 from "../../assets/Kebab.png";
import Work7 from "../../assets/Art&Craft.png";
import Work8 from "../../assets/School.png";
import Work9 from "../../assets/Work-9.png";
import Work10 from "../../assets/Work-10.png";


const Menu = [
  {
    id: 1,
    image: Work1,
    title: "Classified Ads",
    description: `Under Maintenance`,
    category: "Development",
    link: "https://classified.z8tech.one/admin/login",
  },

  {
    id: 2,
    image: Work2,
    title: "Warehouse Management",
    description: `Authentication System, Invoice Generation, CSV and PDF Export, Email Notifications, Revenue Analytics, Reporting.[Credintials : Email: admin@mail.com pass: password]`,
    category: "Development",
    link: "https://smsinventory.ca/login",
  },

  {
    id: 3,
    image: Work9,
    title: "Cluster Antivirus",
    description: `Booking free product trial, premium subscription
with payment method, full admin dashboard
access(Statistics, order,trial,product key),upload and
download key by excel or csv 
[Credintials : Email: admin@cluster.com pass: admin123]
(*Note: use /login for login page)

`,
    category: "Development",
    link: "https://cluster-project.vercel.app/",
  },

  {
    id: 4,
    image: Work10,
    title: "Business Management(Under development)",
    description: `Authentication System, POS system,ecommerce type product management, warehouse management, setting different businesses,Report CSV and PDF Export, Admin and user dashboard, sales management, purchase management etc.
    [Credintials : Email: b@gmail.com pass: admin123]`,

    category: "Development",
    link: "https://inventory-management-alpha-ebon.vercel.app/",
  },



  {
    id: 5,
    image: Work3,
    title: "Turf-BD",
    description: ` Booking with time slots, Report Generation, and a Subscription System using Laravel Job & scheduling `,
    category: "Development",
    link: "https://turfbd.net/",
  },

  {
    id: 6,
    image: Work4,
    title: "Guirdian News",
    description: ` Developed innovative news website.With subscription system leveraging latest web technologies.Access of full admin dashboard for handling payment and article order system.[Credintials: Email: user1@gmail.com pass: 123456Aa]`,
    category: "Development",
    link: "https://the-guirdian-news.netlify.app/",
  },
  {
    id: 7,
    image: Work5,
    title: "Product Query",
    description: ` It is a robust search functionality allowing users to easily find products by name, category, brand, or any relevant keywords.User can recommend any product by commenting details page`,
    category: "Development",
    link: "https://ahad-product-query.web.app/",
  },

  {
    id: 8,
    image: Work6,
    title: "Kebab Amigos",
    category: "Design",
    description:
      "Simple Design of a kebab restaerent about their informations and various departments and showcasing of different menus",
    link: "https://kebab-amigos.netlify.app/",
  },

  {
    id: 9,
    image: Work7,
    title: "Art & Craft",
    category: "Development",
    description: `
Unique Arts & Crafts is an online platform offering diverse art tutorials, interactive learning, community engagement, and resources. It features personal portfolio showcases and organizes live events and workshops. `,
    link: "https://assignment-10-ahad.netlify.app/",
  },

  {
    id: 10,
    image: Work8,
    title: "Modern-School",
    description:
      "It utilizes to create a visually appealing and user-friendly interface for students, parents, and teachers.",
    category: "Design",
    link: "https://demo-project-ahad.netlify.app/",
  },
];

export default Menu;
